import { render, staticRenderFns } from "./Boards4User.vue?vue&type=template&id=0bee3cab&scoped=true&"
import script from "./Boards4User.vue?vue&type=script&lang=js&"
export * from "./Boards4User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_cache-loader@4.1.0_webpack@4.46.0__css-loader@3.6.0_webpack@4.46.0__l_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bee3cab",
  null
  
)

export default component.exports